// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback } from 'react';
import FormDialog from '../../../components/Dialog/FormDialog';
import useRequestProviderService from '../../../hooks/mutations/registry/onboarding/useRequestProviderService';
import useMutate from '../../../hooks/mutations/useMutate';
import { ERR_REQ_PROVIDER_SVC, SUC_REQ_PROVIDER_SVC } from '../../../utils/strings';

type DialogProps = {
  open: boolean;
  onClose: () => void;
};

export const RequestProviderServiceDialog = ({ open, onClose }: DialogProps) => {
  const requestProviderService = useRequestProviderService();
  const mutate = useMutate();

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSubmit = useCallback(async () => {
    const res = await mutate(
      requestProviderService,
      undefined,
      SUC_REQ_PROVIDER_SVC,
      ERR_REQ_PROVIDER_SVC,
    );
    handleClose();
    return res;
  }, [requestProviderService, handleClose, mutate]);

  const isLoading = false;
  if (isLoading) return null;

  const disableSubmit = false;

  return (
    <FormDialog
      open={open}
      title="Request Provider Service"
      onCancel={handleClose}
      onSubmit={handleSubmit}
      submitName="Request"
      isSubmitDisabled={disableSubmit}
    />
  );
};
